var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"1ef483a2af0dd10fc1282173d0aaad6881220928"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["app-web@treefort-systems"]={id:"1ef483a2af0dd10fc1282173d0aaad6881220928"};
      